"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAbsolutePeriod = isAbsolutePeriod;
exports.isRelativePeriod = isRelativePeriod;
function isAbsolutePeriod(period) {
    return (period.start instanceof Date &&
        period.end instanceof Date);
}
function isRelativePeriod(period) {
    return !isAbsolutePeriod(period);
}
//# sourceMappingURL=periodGuard.js.map